import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { DateNextActionForm } from "Order/Components/Form/DateNextActionForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";

const orderResources = Resources.base.order.editForm;

export const DateNextActionCardWidget = () => {
	const { t } = useResource();

	return (
		<BaseCard title={t(orderResources.nextActionDate)}>
			<DateNextActionForm />
		</BaseCard>
	);
};
